import action from './action';
import actionTypes from './actionTypes';
import {reduxUtils} from './settings';

export default {
    action,
    actionTypes,
    utils: reduxUtils
}